import axios from 'axios';

const state= {
    Items:{ 
        data:[],
        total : 0,
        pages: {
            totalPage : 1,
            page : 1,
            limit : 25,
            filter : {
              id:null,
              name:null,
              address_line:null,
              phone: null,
              is_fm_company: false,
              is_supplier : true,
              contact_name : ''
    
            }
        }
    },
    Loadings:{
        list:false,
        create:false,
    },
    AllItem : [],
    organizations: [],
    organizationsUser: [],
    organization: null
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
    AllItems : (state) => state.AllItem,
    Organizations : (state) => state.organizations,
    organizationsUser : (state) => state.organizationsUser,
    organization : (state) => state.organization,
};

const actions = {
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"list",val:true});
            global.axios.get(`api/organizations`, {params:params})
                .then(response => {
                    response.data.data.pages = params
                    commit( 'setLoadings', {key:"list",val:false});
                    commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async searchItemsInUser({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/organizations`, { params: params})
                .then(response => {
                    commit( 'setOrganizationsUser', { meth: 'list', data: response.data.data.items } );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async createItem({commit}, params){
        //params.isPlatformOwner = params.isPlatformOwner ? 1:0;
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"create",val:true});
            global.axios.post(`api/organizations`, params)
                .then(response => {
                    commit( 'setLoadings', {key:"create",val:false});
                    commit( 'createSupplier', response.data.data );
                    commit ( 'setOrganizationItems', response.data.data);
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, params){
        //params.isPlatformOwner = params.isPlatformOwner ? 1:0;
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"create",val:true});
            global.axios.put(`api/organizations/${params.id}`, params)
                .then(response => {
                    commit( 'setLoadings', {key:"create",val:false});
                    // commit( 'setOrganizationsUser', { meth: 'update', data: response.data.data });
                    commit( 'updateListOraganization', response.data.data)
                    //commit( 'updateItemOrganizations', { index: params.index, data:response.data.data });
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoadings', {key:"list",val:true});
            global.axios.delete(`api/organizations`, {
                data:{
                    ids:params
                }
            })
                .then(response => {
                    commit( 'setLoadings', {key:"list",val:false});
                    commit( 'setOrganizationsUser', { meth: 'delete', data: params });
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async getAllItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/organizations/all`, {params:params})
                .then(response => {
                    commit( 'setAllItems', response.data.data.items );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async searchOrganizations({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios(`api/organizations/search`, {
                method: "GET",
                params:  {
                    filter: params
                },
                headers: {
                  Accept: "application/json",
                }
            })
            .then(response => {
                resolve(response)
            })
            .catch(error => reject( error ))
        });
    },
    async getOrganizations({commit}, params){
       
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/organizations/${params}`)
            .then(response => {
                commit( 'setOrganizationItems', response.data.data );
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getOrganizationsInPayment({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/organizations`, { params: params})
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit );
        state.Items.data = data.items;
        state.Items.total = data.total;
        state.Items.pages = data.pages;
    },
    /*updateItemOrganizations(state, data) {
        if(data.index) {
            state.Items.data[data.index] = data.data
        }
    },*/
    setLoadings (state,data) {
        if(data.key === "list"){
            state.Loadings.list = data.val;
        }
        if(data.key === "create"){
            state.Loadings.create = data.val;
        }
    },
    setAllItems (state,data) {
        state.AllItem = data;
    },
    setOrganizations (state,data) {
        state.organizations = data;
    },
    setOrganizationsUser (state,data) {
        if(data.meth.includes('list')) {
            state.organizationsUser = data.data
        }
        if(data.meth.includes('create')) {
            state.organizationsUser.push(data.data)
        }
        if(data.meth.includes('update')) {
            state.organizationsUser = state.organizationsUser.map(item => item.id == data.data.id ? data.data : item)
        }
        if(data.meth.includes('delete')) {
            state.organizationsUser = state.organizationsUser.filter(item => item.id.toString().includes(data.data) == false)
        }
    },
    createSupplier (state, data) {
        if(state.Items.data.length > 0) {
            state.Items.data.push(data);
            state.Items.total ++;
            return;
        } 
    },
    setOrganizationItems (state, data) {
        state.organization = data;
    },
    updateListOraganization(state, data) {
        if(state.Items.data.length > 0) {
           state.Items.data =  state.Items.data.map(item => item.id === data.id ? data : item)
        }
    },
    checkSuppler(state, data) {
        let isExisted = state.Items.data.find(function(supplier) { 
            return supplier.id = data.id; 
          }); 
        if(data.is_supplier) {
            if(isExisted) {
                return state.Items.data = state.Items.data.map(item => item.id == data.id ? data : item)
            }
            if(state.Items.data.length > 0) {
                state.Items.data.push(data);
                state.Items.total ++;
                return;
            }
        }
        if(isExisted) {
           return state.Items.data = state.Items.data.filter(item => item.id != data.id)
        }
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}